import { InputAdornment, MenuItem, Stack, TextField } from "@mui/material";
import { useMemo } from "react";

interface ILightningLanderFlexFieldProps {
  flexValue: string;
  handleFlexChange: (newFlexValue: string) => void;
}

function LightningLanderFlexField({
  flexValue,
  handleFlexChange,
}: ILightningLanderFlexFieldProps) {
  const [flexGrow, flexShrink, flexBasisWithUnit] = flexValue.split(" ");
  const [flexBasis, flexBasisUnit] = useMemo(() => {
    const match = flexBasisWithUnit?.match(/^(\d+)(px|%)?$/) || [];
    return [match[1] || "auto", match[2] || "%"];
  }, [flexBasisWithUnit]);

  return (
    <Stack spacing={2} mt={2}>
      <Stack spacing={2} direction="row">
        <TextField
          label="Flex Grow"
          value={flexGrow || "0"}
          onChange={(e) =>
            handleFlexChange(
              `${e.target.value} ${
                flexShrink || "1"
              } ${flexBasis}${flexBasisUnit}`
            )
          }
          size="small"
          fullWidth
        />
        <TextField
          label="Flex Shrink"
          value={flexShrink || "1"}
          onChange={(e) =>
            handleFlexChange(
              `${flexGrow || "0"} ${
                e.target.value
              } ${flexBasis}${flexBasisUnit}`
            )
          }
          size="small"
          fullWidth
        />
      </Stack>
      <Stack spacing={2} direction="row">
        <TextField
          label="Flex Basis"
          value={flexBasis || "auto"}
          onChange={(e) =>
            handleFlexChange(
              `${flexGrow || "0"} ${flexShrink || "1"} ${
                e.target.value
              }${flexBasisUnit}`
            )
          }
          size="small"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <TextField
                  select
                  value={flexBasisUnit || "%"}
                  onChange={(e) =>
                    handleFlexChange(
                      `${flexGrow || "0"} ${flexShrink || "1"} ${flexBasis}${
                        e.target.value
                      }`
                    )
                  }
                  size="small"
                  variant="standard"
                  sx={{
                    width: 40,
                    "& .MuiSelect-select": {
                      padding: 0,
                      textAlign: "center",
                    },
                  }}
                >
                  {["%", "px"].map((unitOption) => (
                    <MenuItem key={unitOption} value={unitOption}>
                      {unitOption}
                    </MenuItem>
                  ))}
                </TextField>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
    </Stack>
  );
}

export default LightningLanderFlexField;
